import React, { useContext, useState, useEffect, useRef } from "react";
import { StoreContext } from "../../../Store/Provider";
import Header from "../Home/Header/Header";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import Sidebar from "./../Home/Sidebar/Sidebar";
import axios from "axios";
import { CircularProgress } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import "./forgotPassword.css";
import { NotificationManager } from "react-notifications";
import { HOST_URL } from "../../../Config";
import { ProjectName } from "../../../Config";
import { routeConstant } from "../../../Route/utils/routeConstant";
import { useNavigate } from "react-router-dom";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ForgotPassword(props) {
  const context = useContext(StoreContext);
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [openalert, setOpenalert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [severity, setSeverity] = useState("error");
  const inputRef = useRef();
  const history = useNavigate();

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenalert(false);
  };

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const onSave = async () => {
    if (!username) {
      NotificationManager.error("Please enter Email");
    } else if (
      !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        username
      )
    ) {
      NotificationManager.error("Please enter valid Email");
    } else {
      setLoading(true);
      const URL = `${HOST_URL}api/v1/Auth/RequestResetPassword?mail=${username}`;
      await axios
        .post(URL)
        .then((res) => {
          if (res.data.Success) {
            NotificationManager.success(res.data.ResultMessage, "", 3000);
            history(routeConstant.Login);
          } else {
            NotificationManager.error(res.data.ResultMessage, "", 3000);
          }
        })
        .catch((err) => {
          console.log(err);
          NotificationManager.error("Something went wrong!", "", 3000);
        });
      setLoading(false);
    }
  };

  return (
    <div className="home">
      <Header />
      <div className="shipmentsListingHome">
        <Drawer
          variant="persistent"
          className={clsx(classes.drawerLeft, {
            [classes.drawerOpen]: context.menuBar,
            [classes.drawerClose]: !context.menuBar,
          })}
          classes={{
            paper: clsx(classes.drawerPaperleft, {
              [classes.drawerOpen]: context.menuBar,
              [classes.drawerClose]: !context.menuBar,
            }),
          }}
        >
          <Sidebar />
        </Drawer>
        <main className={clsx(classes.content)}>
          <div className="loginScreen">
            <div
              className="loginScreenImage"
              style={{
                backgroundImage: `url(/${ProjectName}/Assets/Images/loginBg.svg)`,
                backgroundSize: "cover",
              }}
            >
              <img
                src={`/${ProjectName}/Assets/Images/LogoTransparent.png`}
                alt="LogoTransparent"
              />
            </div>
            <div className="loginScreenForm">
              <div className="loginForm">
                <div className="loginFormHeading">
                  <span>Forgot Password</span>
                </div>
                <div>
                  <input
                    type="text"
                    className="form-control"
                    value={username}
                    ref={inputRef}
                    placeholder="Enter your e-mail address"
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div className="forgotPass">
                  <span
                    onClick={() => {
                      history(routeConstant.Login);
                    }}
                  >
                    Login
                  </span>
                </div>
                <div className="loginFormSubmit">
                  <Button
                    variant="contained"
                    className="form-control"
                    onClick={onSave}
                  >
                    {loading ? <CircularProgress size="2rem" /> : "Send Email"}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={openalert}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert severity={severity} onClose={handleClose}>
          {alertText}
        </Alert>
      </Snackbar>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  content: {
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerLeft: {
    width: "18%",
    flexShrink: 0,
    whiteSpace: "nowrap",
  },
  drawerPaperleft: {
    top: "auto",
    height: "calc(100% - 3rem)",
    visibility: "visible !important",
    transform: "translateX(0px) !important",
  },
  drawerOpen: {
    width: "18%",
    minWidth: "16rem",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: "2.5rem",
  },
}));

export default ForgotPassword;
